import '../../fonts.css'
import { useState } from "react";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';


const ShareButton = () => {
  const [showCopyLink, setShowCopyLink] = useState(false);
  const [copied, setCopied] = useState(false);
  
  const handleClick = () => {
    setShowCopyLink(true);
  };

  const handleClose = () => {
    setShowCopyLink(false);
  };

  // Get current URL with parameters for sharing
  const getCurrentShareLink = () => {
   
    let linkToShare =  window.location.href;
    if(linkToShare.includes("3d-view"))
    {
      linkToShare = sessionStorage.getItem("ShareURL");
    }
    return linkToShare;
  };

  const handleCopy = async () => {
    const link = getCurrentShareLink();
    
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          position: "absolute",
          top: "25px",
          right: "25px",
          color: '#4a5568', 
          zIndex: 1,
          border: '1px solid #e2e8f0',
          outline: "none",
          padding: '1rem',
          display: 'flex',
          backgroundColor: 'white',
          borderRadius: '9999px',
          height: "40px",
          width: "40px",
          cursor: "pointer",
          fontFamily: "GoldbeckNextRegular",
          justifyContent: "center",
          alignItems: "center"
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = '#EEEFF0'; 
          e.currentTarget.style.color = '#1a202c';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = 'white'; 
          e.currentTarget.style.color = '#4a5568';
        }}
      >
        <ShareOutlinedIcon style={{ width: '20px', height: '20px' }} />
      </button>
      
      {/* Inline Copy Link Modal */}
      {showCopyLink && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '32px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
          }}>
            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <h2 style={{ 
                fontSize: '20px', 
                fontWeight: '600', 
                color: '#1a202c', 
                marginBottom: '8px',
                fontFamily: 'GoldbeckNextRegular'
              }}>
                Teilen
              </h2>
              <p style={{ 
                color: '#718096', 
                fontSize: '14px', 
                lineHeight: '1.5',
                fontFamily: 'GoldbeckNextRegular'
              }}>
                Teile deine Auswahl mit Kolleginnen und Kollegen.
              </p>
            </div>

            {/* Link Section */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '500', 
                color: '#4a5568', 
                marginBottom: '8px',
                fontFamily: 'GoldbeckNextRegular'
              }}>
                Link
              </label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="text"
                  value={getCurrentShareLink()}
                  readOnly
                  style={{
                    flex: 1,
                    padding: '8px 12px',
                    backgroundColor: '#f7fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '14px',
                    color: '#4a5568',
                    outline: 'none',
                    fontFamily: 'GoldbeckNextRegular'
                  }}
                  
                />
                <button
                  onClick={handleCopy}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    border: copied ? '1px solid #68d391' : '1px solid #e2e8f0',
                    backgroundColor: copied ? '#f0fff4' : 'white',
                    color: copied ? '#3EBAEC' : '#718096',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s',
                    outline: 'none'
                  }}
                  title={copied ? 'Copied!' : 'Copy link'}
                    onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#EEEFF0'; 
                    e.currentTarget.style.color = '#1a202c';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'white'; 
                    e.currentTarget.style.color = '#4a5568';
                  }}
                >
                  {copied ? '✓' : '📋'}
                </button>
              </div>
            </div>

            {/* Close Button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                onClick={handleClose}
                style={{
                  padding: '12px 32px',
                  backgroundColor: '#3EBAEC',
                  color: 'white',
                  fontWeight: '500',
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  outline: 'none',
                  fontFamily: 'GoldbeckNextRegular'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#42B0E8';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#3EBAEC';
                }}
              >
                Schließen
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareButton;